// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingTitle_wrapper__Svh1k","loading":"LoadingTitle_loading__xwW65"};